import { Link } from 'react-router-dom';

const ctaBgUrl = 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20gradient%20background%20with%20geometric%20security%20patterns%2C%20soft%20glow%20effects%2C%20professional%20modern%20aesthetic%2C%20clean%20minimal%20design%2C%20no%20text%2C%20digital%20network%20motif%2C%20flowing%20curves&width=1600&height=400&seq=cta-banner-01&orientation=landscape';

export default function CTABanner() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={ctaBgUrl}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-primary-900/85"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-xl md:text-3xl font-bold text-background-50 mb-4">
          知识是最好的安全防护
        </h2>
        <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-8">
          在复杂的网络环境中，掌握正确的安全知识是保护自己的第一步。
          浏览我们的文章，建立属于你的安全知识体系。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/compliance"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50 text-primary-700 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            浏览所有文章
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/10 border border-background-50/25 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}